'use strict';

var $ = require('jquery');
var navTop = $('.navbar-tshop');
var navOffset = navTop.offset();
var navOffsetTop = navOffset ? navOffset.top : 0;

var setMenu = function setMenu() {
  if ($(window).scrollTop() >= navOffsetTop) {
    $('body').addClass('stick-menu');
    $('.navbar-bottom').css('margin-top', navTop.height());
  } else {
    $('body').removeClass('stick-menu');
    $('.navbar-bottom').attr('style', '');
  }
};

$(function () {
  if (window.matchMedia("(min-width: 768px)").matches) {
    $(window).on('scroll', function () {
      setMenu();
    });
    setMenu();
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/linksoft-albatros/src/plugins/sticky.js
// module id = 959
// module chunks = 0